export interface CitizenshipSelection {
  citizenshipStatus?: CitizenshipSelectionOptions;
  uscisANumber?: string;
  authorizedAlienNumber?: string;
  authorizedI94Number?: string;
  foreignPassportNumber?: string;
  passportCountry?: string;
}

export default CitizenshipSelection;

export enum CitizenshipSelectionOptions {
  CITIZEN = 'CITIZEN_OF_UNITED_STATES',
  NON_CITIZEN = 'NONCITIZEN_NATIONAL',
  PERMANENT_RESIDENT = 'LAWFUL_PERMANENT_RESIDENT',
  ALIEN = 'ALIEN_AUTHORIZED_TO_WORK',
}
export const CITIZENSHIPOPTIONS = {
  [CitizenshipSelectionOptions.CITIZEN]: 'A citizen of the United States.',
  [CitizenshipSelectionOptions.NON_CITIZEN]: 'A noncitizen national of the United States.',
  [CitizenshipSelectionOptions.PERMANENT_RESIDENT]: 'A lawful permanent resident.',
  [CitizenshipSelectionOptions.ALIEN]: 'An alien authorized to work.',
};
